import fetchAPI from "../services/fetch/fetch.service";
import { v4 as uuidV4 } from "uuid";

export const getApplicationData = uuid => {
    return fetchAPI
        .service()
        .get(`/api/data?guid=${uuid}`)
        .then(data => data);
};

export const getUuid = () => {
    const item = localStorage.getItem("uuid");
    if (item !== null) {
        return item;
    }
    const uuid = uuidV4();
    localStorage.setItem("uuid", uuid);
    return uuid;
};

/*export const getApplicationData = () => {
    return fetchAPI.service().get('/api').then( data => data);
};*/

export const postQuestionsAndComment = (payload, id) => {
    return fetchAPI
        .service()
        .post(`/api/rate/${id}`, payload)
        .then(data => data);
};

export const initializePayment = payload => {
    return fetchAPI
        .service()
        .post(`/api/accreditation/initialize`, payload)
        .then(data => data);
};

export const confirmPayment = payload => {
    return fetchAPI
        .service()
        .post("/api/accreditation/confirm", payload)
        .then(data => data);
};
